
const stateManager = require('../state/stateManager');
const basketVersionAction = require('../state/actions/basket/basketVersionAction');
const menuCategoryAction = require('../state/actions/menuCategory/menuCategoryAction');
const stringUtil = require('../string/stringUtil');
const constants = require('../domain/constants');
const storeUtil = require('../store/storeUtil');
const localizationUtils = require('../localization/localizationUtils');

var basketVersion = 0;

module.exports.resetBasket = function(dispatchType)
{
    var state = stateManager.getStore().getState();
    var previousDispatchType = state.basket.order?.dispatchType ?? "";

    if (!dispatchType)
    {
        if (!stringUtil.isStringNullOrEmpty(previousDispatchType))
            dispatchType = previousDispatchType;
        else
            dispatchType = storeUtil.getDefaultDispatchType();
    }
 
    state.basket = {};
    state.basket.doRequireCutleries = false;
    state.basket.doRequireEnrichment = true;
    state.basket.voucherCode = "";
    state.basket.dispatchTimeInMinutes = "";
    state.basket.order = {};
    state.basket.order.tableNumber = state.tableNumber;
    state.basket.order.number = "";
    state.basket.order.saleItems = [];
    state.basket.order.dispatchType = dispatchType;
    state.basket.order.paymentMethod = "";
    state.basket.order.paidAmount = 0;
    state.basket.order.instructions = "";
    state.basket.order.saleType = constants.saleTypes.sale;
    state.basket.order.channel = state.channel;
    state.basket.order.venueCode = state.venueCode;

    state.basket.dispatchInfo = {};
    state.basket.dispatchInfo.deliveryAddress = "";
    state.basket.dispatchInfo.distance = -1;
    state.basket.dispatchInfo.deliveryCharges = -1;

    state.basket.creditCardTransactionResult = {};


    if (!stringUtil.areStringSame(dispatchType, previousDispatchType))
    {
        state.currentMenu = null;

    }
 
    incrementBasketVersion();
}

module.exports.resetMenu = function(saleMenu, rewardMenu)
{
    var state = stateManager.getStore().getState();
    state.currentMenu = saleMenu;
    
    stateManager.getStore().dispatch(menuCategoryAction.createAction(-1));

    if(stringUtil.areStringSame(stateManager.getStore().getState().currentMode, constants.applicationMode.overPhonePayment))
        incrementBasketVersion();
    else
        this.resetBasket();
}

module.exports.addItemToBasket = function(saleItem)
{
    var state = stateManager.getStore().getState();
    var basket = state.basket;

    this.markBasketForEnrichment();
    basket.order.saleItems.push(saleItem);
    incrementBasketVersion();
}

module.exports.getTotalOrderPrice = function()
{
    var state = stateManager.getStore().getState();
    var basket = state.basket;

    var price = 0;
    basket.order.saleItems.forEach (saleItem =>
    {
        price = price + this.getTotalItemPrice(saleItem);
    });

    return price;
}

module.exports.getTotalOrderVAT = function()
{
    var state = stateManager.getStore().getState();
    var basket = state.basket;

    var totalVat = 0;
    basket.order.saleItems.forEach (saleItem =>
    {
        totalVat = totalVat + this.getTotalItemVAT(saleItem);
    });

    return totalVat;
}

module.exports.getTotalItemPrice = function(saleItem)
{
    var price = saleItem.unitPrice * saleItem.quantity;
    saleItem.saleItems.forEach(saleSubItem =>
        {
            price = price + this.getTotalItemPrice(saleSubItem);
        })

    return price;
}

module.exports.getTotalItemVAT = function(saleItem)
{
    var totalVat = saleItem.vat * saleItem.quantity;
    saleItem.saleItems.forEach(saleSubItem =>
        {
            totalVat = totalVat + this.getTotalItemVAT(saleSubItem);
        })

    return totalVat;
}

module.exports.getTotalCharges = function()
{
    var state = stateManager.getStore().getState();
    var order = state.basket.order;

    if (order.charges == null || order.charges.length <= 0)
        return 0;

    var charges = 0;

    order.charges.forEach(charge =>
        {
            charges = charges + charge.amount;
        });

    return charges;
}

module.exports.getTotalChargesVAT = function()
{
    var state = stateManager.getStore().getState();
    var order = state.basket.order;

    if (order.charges == null || order.charges.length <= 0)
        return 0;

    var totalVat = 0;

    order.charges.forEach(charge =>
        {
            totalVat = totalVat + charge.vat;
        });

    return totalVat;
}

module.exports.getTotalDiscounts = function()
{
    var state = stateManager.getStore().getState();
    var order = state.basket.order;

    if (order.discounts == null || order.discounts.length <= 0)
        return 0;

    var discounts = 0;

    order.discounts.forEach(discount =>
        {
            discounts = discounts + discount.amount;
        });

    return discounts;
}

module.exports.getTotalVat = function()
{
    return this.getTotalOrderVAT() + this.getTotalChargesVAT();
}



module.exports.getTotalBasketPrice = function()
{
    var totalBasketPrice =  this.getTotalOrderPrice() + this.getTotalCharges() - this.getTotalDiscounts();
    if (!localizationUtils.isVatInclusive())
        totalBasketPrice = totalBasketPrice + this.getTotalVat()

    return totalBasketPrice;

}

module.exports.isBasketEmpty = function()
{
    var state = stateManager.getStore().getState();
    var basket = state.basket;

    return basket.order.saleItems.length <= 0;
}

module.exports.isAddressMandatoryForBasket = function()
{
    var state = stateManager.getStore().getState();
    var basket = state.basket;

    return stringUtil.areStringSame(basket.order.dispatchType, "delivery");
}

module.exports.validateBasket = function()
{
    var state = stateManager.getStore().getState();
    var basket = state.basket;

    if(basket == null || basket.order == null)
        return "Your basket is empty.";

    const order = basket.order;

    if(stringUtil.isStringNullOrEmpty(order.dispatchType))
        return 'Please choose dispatch type.';
    
    if(stringUtil.isStringNullOrEmpty(order.paymentMethod) && this.getTotalBasketPrice())
        return "Please choose payment method.";

    if(stringUtil.isStringNullOrEmpty(order.saleType))
        return "Sale Type is missing.";

    if(stringUtil.isStringNullOrEmpty(order.channel))
        return "Sale Channel is missing.";

    if(this.isAddressMandatoryForBasket() && stringUtil.isStringNullOrEmpty(basket.dispatchInfo.deliveryAddress))
        return "Please update your delivery address";
        
    return null;
}

function incrementBasketVersion()
{
    basketVersion = basketVersion + 1;
    stateManager.getStore().dispatch(basketVersionAction.createAction(basketVersion));
}

module.exports.isPaymentOverPhoneApplicableToSale = function(sale)
{
    if(!stringUtil.areStringSame(sale.saleType, constants.saleTypes.hold))
        return false;

    if(!stringUtil.areStringSame(sale.holdReasonCode, constants.holdReasonCode.paymentByPhone))
        return false;

    return true;
}


module.exports.isCurrentBasketForPaymentOverPhone = function()
{
    var state = stateManager.getStore().getState();
    return state.currentMode == constants.applicationMode.overPhonePayment;
}

module.exports.markBasketForEnrichment = function()
{
    var state = stateManager.getStore().getState();
    var basket = state.basket;

    basket.doRequireEnrichment = true;
    if (this.isCurrentBasketForPaymentOverPhone())
    {
        basket.order.discounts = [];
    }
}

